export const ROOT_PATH_AUTH = 'auth';

export const AuthRoutes = {
    LOGIN: {path: 'login', fullPath: `/${ROOT_PATH_AUTH}/login`},
    REGISTER: {path: 'register', fullPath: `/${ROOT_PATH_AUTH}/register`},
    ADMIN_LOGIN: {path: 'admin-login', fullPath: `/${ROOT_PATH_AUTH}/admin-login`}
}